import React from 'react'
import { useTranslation } from 'react-i18next'
import { numberTropicalizer } from '@navent-jobs/config'
import Text from '@navent-jobs/ui-kit/components/text'
import { Container, CenterText, MontoText, HowToText } from './mixins'

const Calculadora = ({ setShowModal, calculadora }) => {
  const empty = !calculadora?.salario?.salarioBruto || calculadora?.salario?.salarioBruto === 0
  const { t } = useTranslation()

  return (
    <div id="calculadora-container">
      <Container isEmpty={empty}>
        {empty ? (
          <CenterText>
            <Text size="xs">{t('fichaAviso.calculadoraSalario.empty')}</Text>
          </CenterText>
        ) : (
          <>
            <MontoText>
              <Text type="title" size="sm" fontWeight="semibold" variant="primary">
                {t('currencyMask.symbol')}
                {numberTropicalizer(calculadora?.salario?.salarioNeto) || 0}
              </Text>
            </MontoText>
            <CenterText>
              <Text size="sm">{t('fichaAviso.calculadoraSalario.salaryDescription')}</Text>
            </CenterText>
          </>
        )}
      </Container>
      <div onClick={() => setShowModal(true)}>
        <HowToText>
          <Text size="xs" fontWeight="semibold">
            ¿Cómo lo calculamos?
          </Text>
        </HowToText>
      </div>
    </div>
  )
}

export default Calculadora
